"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var _fluxActions = require("flux-actions");

var _handleActions;

var initialState = null;

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, ActionTypes.SET_CONSENT_RESPONSES, function (state, action) {
  return action.payload;
}), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(ActionTypes.RESET_CONSENT_RESPONSES, ActionTypes.BOOKING_TIME_CONFLICT), function () {
  return initialState;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;